import {
    Badge,
    Box,
    Button,
    CopyButton,
    JsonInput,
    Text,
    Tooltip,
    rem,
} from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';

const CountCell = ({ cell, accessorKey }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Text>{rowData[accessorKey] || 0}</Text>;
};

const CountColumn = ({ header, accessorKey, columnProps = {} }) => ({
    accessorKey: accessorKey,
    header: header,
    size: 2,
    minSize: 40,
    ...columnProps,
    Cell: ({ cell }) => (
        <CountCell
            cell={cell}
            accessorKey={accessorKey}
        />
    ),
    Footer: (info) => {
        const ignoreCount = ['Bulk Discount', 'Credit', 'TopUp'];

        // e.g. sum of ages
        const total = info.table.getRowModel().rows.reduce((acc, row) => {
            try {
                if (ignoreCount.includes(row.getValue('type'))) return acc + 0;
                return acc + Number(row.getValue(accessorKey));
            } catch {
                return 0;
            }
        }, 0);
        return <Text>{total || 0}</Text>;
    },
});
export default CountColumn;
